import dynamic from 'next/dynamic';
import A from './components/A';
import FixTab from './components/FixTab';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function BKW() {
    if (typeof window !== 'undefined' && !window?.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    return (
        <div className={`bkw ${css['bkw']}`}>
            <A />
            <FixTab />
            <IndexDynamic />
        </div>
    );
}
